import React from 'react';
import IntlMessage from "../../../../../helpers/intlMessage";

import Td from './Td';

function Table ({item}) {
  return (
    <table style={{width: '100%', marginBottom: '7px'}}>
      <tbody>
        <tr>
          <Td colSpan='1' title={<IntlMessage id = "dashboards.taskControl.patient"/>} value={item.paciente}/>
          <Td colSpan='2' title={<IntlMessage id = "dashboards.general.socialName"/>} value={item.pacienteNomeSocial}/>
        </tr>
        <tr>
          <Td colSpan='3' title={<IntlMessage id = "dashboards.taskControl.pathologistDoctor"/>} value={item.medicoNome}/>
        </tr>
        <tr>
          <Td colSpan='3' title={<IntlMessage id = "dashboards.taskControl.exam"/>} value={item.exame}/>
        </tr>
        <tr>
          <Td title={<IntlMessage id = "dashboards.taskControl.blade"/>} value={item.lamina} styleTd={{width: '48px'}}/>
          <Td title={<IntlMessage id = "dashboards.taskControl.status"/>} value={item.finalizacao} styleTd={{width: '48px'}}/>
          <Td title={<IntlMessage id = "dashboards.taskControl.canceled"/>} value={item.cancelada} styleTd={{width: '48px'}}/>
        </tr>
      </tbody>
    </table>
  );
}

export default Table;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Citologia/Impressao/Table/index.js